export default __webpack_public_path__ + "assets/logos-partners/microsoft/6bc3990e40160c16002b32b61099b4c2.png";